/**
 * Timing Constants
 *
 * Centralized timing values used throughout the application.
 * All values are in milliseconds.
 */

/**
 * Maximum time to wait for post-authentication flow to complete
 * before resetting the loading state and auth flag.
 *
 * This prevents the UI from being stuck in a loading state if
 * the post-auth organization check fails or takes too long.
 *
 * Increased to 15 seconds to accommodate 3 retries with exponential backoff
 * (total retry time: ~7s + network + processing time)
 */
export const POST_AUTH_TIMEOUT_MS = 15000; // 15 seconds

/**
 * Retry delays for organization status check after login.
 * Uses exponential backoff strategy: 1s, 2s, 4s
 *
 * Total max retry time: ~7 seconds across 3 attempts
 */
export const ORG_CHECK_RETRY_DELAYS_MS = [1000, 2000, 4000];

/**
 * Initial delay after CallAgent disposal to allow
 * browser to start releasing media device permissions.
 *
 * Some browsers need a brief moment after disposal
 * before the devices become available again.
 */
export const CALL_AGENT_DISPOSAL_DELAY_MS = 100;

/**
 * Extended delay for media device cleanup to ensure
 * all resources are fully released by the browser.
 *
 * This gives time for:
 * - CallAgent disposal to complete
 * - Media streams to be fully stopped
 * - Browser to release device locks
 */
export const MEDIA_CLEANUP_DELAY_MS = 500;

/**
 * Maximum number of retry attempts for organization check
 */
export const ORG_CHECK_MAX_RETRIES = 3;

/**
 * Maximum number of retry attempts on error page
 */
export const ERROR_PAGE_MAX_RETRIES = 3;
